import React from 'react'
import './footer.css'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'


const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>AG</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://github.com/alisaimtiaz"><BsGithub/></a>
        <a href="https://www.linkedin.com/in/alisa-g-140715150/"><BsLinkedin/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Alisa's Portfolio. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer